import React from "react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";

const LoadingScreen = () => {
  return (
    <div className="loading_screen">
      <img className="loading_gif" src={loaderGIF} alt="loading..." />
    </div>
  );
};

export default LoadingScreen;
